// extracted by mini-css-extract-plugin
module.exports = {"colorBox":"styles_colorBox__2GVsW","grayLight":"styles_grayLight__Pq1kY","white":"styles_white__2tDam","whiteGrayBorder":"styles_whiteGrayBorder__qo9cN"};